angular.module('unica_feedback_category.feedback_category_services', []);